<template>
  <div>
    <div class="tms-carousel">
      <div class="block">
        <van-swipe
          indicator-color="#ffffff"
          :height="config.property_data.height"
          :autoplay="3000"
          @change="onChange"
        >
          <van-swipe-item
            v-for="(item, index) in config.link_data"
            :key="index"
          >
            <div
              @click="jump(item.link_data)"
              class="image-list"
              :title="item.link_name || '未命名'"
              :style="`padding: 0 ${config.property_data.padding}px`"
            >
              <img
                :src="item.image_url || default_imgurl"
                :style="`border-radius:${config.property_data.borderRadius}px`"
              />
            </div>
          </van-swipe-item>
        </van-swipe>
      </div>
    </div>
  </div>
</template>


<script>
import { redirectURL } from "@/js/jump";
export default {
  name: "tms-image_list",
  props: ["config", "isEditorStatus"],

  data() {
    return {
      default_imgurl:
        "https://img.mockuai.com/tms/2018/1/10/upload_48dfb5b82f032311cb9207f142a95b89.png",
    };
  },

  methods: {
    jump(item) {
      if (this.isEditorStatus || !item) {
        return;
      }
      redirectURL(item.toString(), "seller");
    },
    onChange(index) {
      const container = document.querySelector(".outer-container");
      container.style.backgroundColor = this.config.link_data[index].color;
    },
  },
  computed: {
    conf() {
      return this.config.link_data;
    },
  },
  watch: {
    deep: true,
    "config.link_data"(value) {
      console.log(value, "1111");
      const container = document.querySelector(".outer-container");
      container.style.backgroundColor = this.config.link_data.length
        ? this.config.link_data[0].color
        : "";
    },
  },
};
</script>
<style  lang="scss" scoped>
@import "./index.scss";
</style>